/* 订单详情--生产资料部分 */
<template>
  <div class="orders-means">
    <Row class="means" type="flex" align="middle">
      <Col span="12">
        <Row
          style="margin-bottom:15px;"
          :gutter="20"
          type="flex"
          justify="start"
          align="middle"
        >
          <Col span="6" class="ellipsis">
            <span class="insert">图纸：</span>
            <span>{{
              fabric_swatches(orderDiaryDescResponseVOList[0]).txt
            }}</span>
          </Col>
          <!-- <Col span="3"> -->
          <!-- <button
              v-if="fabric_swatches(orderDiaryDescResponseVOList[0]).download"
              @click="meansDownloadHandle(orderDiaryDescResponseVOList[0].coverFile)"
              :disabled="BUTTON_NAME['ORDER_DOWN_LOAD']"
              class="btn-txt"
            >{{BUTTON_NAME['ORDER_DOWN_LOAD'] ? '下载' : '下载'}}</button> -->
          <!-- {{fabric_swatches(orderDiaryDescResponseVOList[0]).unconfirmedNum}}条未确认 -->
          <!-- </Col> -->
          <Col span="10" class="aligin-center">
            <div
              class="tag-color-green"
              v-if="fabric_swatches(orderDiaryDescResponseVOList[0]).type"
              color="green"
            >
              <i
                class="iconfont icon-hook"
                style="color: #44D7B6; font-size:12px; display:inline-block; margin-right:5px;"
              ></i>
              已确认
            </div>
            <Tag
              v-if="
                fabric_swatches(orderDiaryDescResponseVOList[0]).download &&
                  !fabric_swatches(orderDiaryDescResponseVOList[0]).type
              "
              color="red"
              @click.native="toUrlDetails"
              >未确认</Tag
            >
            <Button
              v-if="
                fabric_swatches(orderDiaryDescResponseVOList[0]).download &&
                  !fabric_swatches(orderDiaryDescResponseVOList[0]).type
              "
              type="text"
              @click="toUrlDetails"
              style="margin-left:5px"
              ><span style="color:rgb(107 107 107);">点击去确认</span></Button
            >
          </Col>
          <!-- <Col span="6">
            <button
              v-if="fabric_swatches(orderDiaryDescResponseVOList[0]).download && !fabric_swatches(orderDiaryDescResponseVOList[0]).type"
              @click="meansComfrimHandle(orderDiaryDescResponseVOList[0], 5)"
              class="btn-txt"
            >确认图纸</button>
            <span
              v-if="fabric_swatches(orderDiaryDescResponseVOList[0]).download && fabric_swatches(orderDiaryDescResponseVOList[0]).type"
              class="c-9c m-l-10"
            >已确认图纸</span>
          </Col> -->
        </Row>

        <Row
          style="margin-bottom:15px;"
          :gutter="20"
          type="flex"
          justify="start"
          align="middle"
        >
          <Col span="6" class="ellipsis">
            <span class="insert">面料：</span>
            <span>{{
              fabric_swatches(orderDiaryDescResponseVOList[2]).txt
            }}</span>
          </Col>
          <Col span="10" class="aligin-center">
            <div
              class="tag-color-green"
              v-if="fabric_swatches(orderDiaryDescResponseVOList[2]).type"
              color="green"
            >
              <i
                class="iconfont icon-hook"
                style="color: #44D7B6; font-size:12px; display:inline-block; margin-right:5px;"
              ></i>
              已确认
            </div>
            <!--  -->
            <Tag
              v-if="
                fabric_swatches(orderDiaryDescResponseVOList[2]).download &&
                  !fabric_swatches(orderDiaryDescResponseVOList[2]).type
              "
              @click.native="toUrlDetails"
              color="red"
              >未确认</Tag
            >
            <Button
              v-if="
                fabric_swatches(orderDiaryDescResponseVOList[2]).download &&
                  !fabric_swatches(orderDiaryDescResponseVOList[2]).type
              "
              type="text"
              @click="toUrlDetails"
              style="margin-left:5px;color:rgb(107 107 107);"
              ><span style="color:rgb(107 107 107);">点击去确认</span>
            </Button>
          </Col>
          <!-- <Col span="6">
            <button
              v-if="fabric_swatches(orderDiaryDescResponseVOList[2]).download && !fabric_swatches(orderDiaryDescResponseVOList[2]).type"
              @click="meansComfrimHandle(orderDiaryDescResponseVOList[2], 7)"
              class="btn-txt"
            >全部确认面料</button>
            <span
              v-if="fabric_swatches(orderDiaryDescResponseVOList[2]).download && fabric_swatches(orderDiaryDescResponseVOList[2]).type"
              class="c-9c m-l-10"
            >面料已确认</span>
          </Col> -->
        </Row>

        <Row
          style="margin-bottom:15px;"
          :gutter="20"
          type="flex"
          justify="start"
          align="middle"
        >
          <Col span="6" class="ellipsis">
            <span class="insert">色板：</span>
            <span>{{
              fabric_swatches(orderDiaryDescResponseVOList[1]).txt
            }}</span>
          </Col>
          <Col span="10" class="aligin-center">
            <div
              class="tag-color-green"
              v-if="fabric_swatches(orderDiaryDescResponseVOList[1]).type"
              color="green"
            >
              <i
                class="iconfont icon-hook"
                style="color: #44D7B6; font-size:12px; display:inline-block; margin-right:5px;"
              ></i>
              已确认
            </div>
            <Tag
              v-if="
                fabric_swatches(orderDiaryDescResponseVOList[1]).download &&
                  !fabric_swatches(orderDiaryDescResponseVOList[1]).type
              "
              color="red"
              @click.native="toUrlDetails"
              >未确认</Tag
            >
            <Button
              v-if="
                fabric_swatches(orderDiaryDescResponseVOList[1]).download &&
                  !fabric_swatches(orderDiaryDescResponseVOList[1]).type
              "
              type="text"
              @click="toUrlDetails"
              style="margin-left:5px"
              ><span style="color:rgb(107 107 107);">点击去确认</span></Button
            >
          </Col>
          <!-- <Col span="6">
            <button
              v-if="fabric_swatches(orderDiaryDescResponseVOList[1]).download && !fabric_swatches(orderDiaryDescResponseVOList[1]).type"
              @click="meansComfrimHandle(orderDiaryDescResponseVOList[1], 6)"
              class="btn-txt"
            >全部确认色板</button>
            <span
              v-if="fabric_swatches(orderDiaryDescResponseVOList[1]).download && fabric_swatches(orderDiaryDescResponseVOList[1]).type"
              class="c-9c m-l-10"
            >色板已全部确认</span>
          </Col> -->
        </Row>
      </Col>
      <!-- v-if="fabric_swatches(orderDiaryDescResponseVOList[1]).download || fabric_swatches(orderDiaryDescResponseVOList[2]).download" -->
      <!-- <Col span="12">
        <Row :gutter="30" type="flex" justify="end" align="middle">
          <Col span="7">
            <a target="_blank" :href="VUE_APP_OLD_BASIC_URL + '/my/order/production/' + this.$route.params.id">
              <Button long>查看</Button>
            </a>
          </Col>
          <Col span="7">
            <Button
              long
              type="primary"
              :loading="BUTTON_NAME['EXPORT_MEANS']"
              @click="exportExcelHandle"
            >导出面料色板</Button>
          </Col>
        </Row>
      </Col> -->
    </Row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      VUE_APP_OLD_BASIC_URL: process.env.VUE_APP_OLD_BASIC_URL,
    }
  },
  props: {
    orderDiaryDescResponseVOList: {
      type: Array,
      default: function() {
        return []
      },
    },
  },
  computed: {
    BUTTON_NAME() {
      return this.$store.state.BUTTON_NAME
    },
  },
  methods: {
    /* 面料色板文案显示 */
    fabric_swatches(params) {
      if (!params) return false

      if (params.status === 0) {
        return { txt: '暂未上传', type: false, download: false }
      } else if (params.status === 1) {
        let obj =
          params.type === 5
            ? {
                txt: params.coverFile ? params.coverFile.name : '',
                type: false,
                download: true,
              }
            : { txt: '暂未上传', type: false, download: false }

        return !params.unconfirmedNum
          ? obj
          : {
              txt: `${params.unconfirmedNum}款未确认`,
              type: false,
              download: true,
            }
      } else {
        return { txt: '全部已确认', type: true, download: true }
      }
    },

    /* 查看生产资料 */
    // checkMeansHandle() {
    //   this.$emit("checkMeans");
    // },

    /* 图纸下载 */
    // meansDownloadHandle(files) {
    //   this.$emit("meansDownload", files);
    // },

    /* 图纸确认 */
    // meansComfrimHandle(item, target) {
    //   this.$emit("meansComfrim", item, target);
    // },

    /* 导出面料色板 */
    exportExcelHandle() {
      this.$emit('exportExcel')
    },

    /* 跳转详情 */
    toUrlDetails() {
      window.location.href =
        this.VUE_APP_OLD_BASIC_URL +
        '/my/order/production/' +
        this.$route.params.id
    },
  },
}
</script>

<style lang="scss">
.orders-means {
  cursor: pointer;
  .means {
    .insert {
      font-weight: 400;
      color: rgba(33, 32, 31, 1);
    }
  }
}
</style>
